import React from 'react'
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'
import { Link, Outlet } from 'react-router-dom'
import ss3 from '../Assets/img/Schemes/ss3.png'; 


const ChannelObservationList = () => {
    const distID = localStorage.getItem('distributorId');
    const userId = localStorage.getItem('userId');
    const boostID = localStorage.getItem('companyIdBooster');
    const parisID = localStorage.getItem('companyIdParis');

    const { data, error, isLoaded } = GetRequest(`/ChannelObservation/GetListOfChannelObservationForUser/${userId}`);

    if (error !== null) {
        return <Error data="Team Contacts" />;
    }
    if (!isLoaded) {
        return <Loading />;
    }
 
  return (
    <>
      <section className="content">
        <div className="container-fluid">
          <div className="row"> 
            <div className="col-md-12">
              <div className="card  card-primary">
                <div className="card-header ">
                  <h3 className="card-title"> 
               Observations Shared By You
                  </h3>  <Link to="/ShareObservations" className='btn btn-success fright'>Share New Observation</Link>
                </div>
                <div className="card-body no-padding">
                <div className="row"> 
                {
                    data.result.map((item, index) => (
                      <div className="col-md-6"> 
                     <div className="card card-warning">
                                                        <div className="card-header ">
                                                            <h5 className="card-title"> Observation </h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <h6>{item.questionInfo}</h6>
                                                            <p>Location:{item.locationInfo}</p>          
                                                            <p>Contact:{item.contactInformation}</p>          
                                                            <p>Status:{item.status}</p>                                                      
                                                        </div>
                                                    </div>
                    </div>
                  ))
                } 
                 </div>
                </div> 

              </div>
            </div> 

          </div>
        </div>
      </section>
    </>
  )
}

export default ChannelObservationList